import RegistrationHeaderText from './RegistrationHeaderText';
export default RegistrationHeaderText;
